import React from 'react';
import { useMediaQuery } from 'react-responsive';

import {
  MEDIA_QUERY_SMALL_SCREEN,
  MEDIA_QUERY_MEDIUM_SCREEN,
  MEDIA_QUERY_LARGE_SCREEN_1200,
} from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';

const PartnerAgentOwnerMarketingPagePropertyPerformance = () => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const isMediumScreen = useMediaQuery({
    query: MEDIA_QUERY_MEDIUM_SCREEN,
  });

  const isLargeScreen = useMediaQuery({
    query: MEDIA_QUERY_LARGE_SCREEN_1200,
  });

  const Container = isLargeScreen ? SrBox : SrFlex;

  return (
    <Container
      padding={isSmallScreen ? '64px 0 0' : '80px 0 0'}
      maxWidth='1160px'
      margin='0 auto'
      justify='between'
      wrap='wrap'
    >
      <SrBox
        boxSizing='border-box'
        maxWidth={isLargeScreen ? null : '465px'}
        padding={isLargeScreen ? '0 20px' : null}
      >
        <SrBox
          maxWidth='465px'
          margin={isLargeScreen ? '0 auto' : null}
        >
          <SrText
            font='greycliff'
            color='fontBlueDark'
            size={isSmallScreen ? '40' : '48'}
            lineHeight={isSmallScreen ? '56px' : '60px'}
            weight='700'
            align={isLargeScreen ? 'center' : null}
            display='block'
          >
            See how your property performs
          </SrText>
        </SrBox>
        <SrBox marginTop={isSmallScreen ? '26px' : '20px'}>
          <SrText
            font='greycliff'
            color='grey500'
            size='18'
            lineHeight='28px'
            weight='600'
            display='block'
            align={isSmallScreen
              ? null
              : isLargeScreen
                ? 'center'
                : null
            }
          >
            Get access to a private website showing you real-time leasing activity
          </SrText>
        </SrBox>
        <SrBox
          margin={isLargeScreen ? '0 auto' : null}
          maxWidth={isLargeScreen ? '600px' : null}
        >
          <SrFlex align='start' marginTop='40px'>
            <img src='/images/calendar-icon.svg' alt='calendar icon' />
            <SrBox marginLeft='20px'>
              <SrText
                font='greycliff'
                color='fontBlueDark'
                size='24'
                lineHeight='32px'
                weight='700'
                display='block'
              >
                See Everything
              </SrText>
              <SrBox marginTop='8px'>
                <SrText
                  font='greycliff'
                  color='grey500'
                  size='16'
                  lineHeight='24px'
                  weight='600'
                  display='block'
                >
                  View property stats, tour feedback, application overviews, all online
                </SrText>
              </SrBox>
            </SrBox>
          </SrFlex>
          <SrFlex align='start' marginTop='32px'>
            <img src='/images/clock-icon.svg' alt='calendar icon' />
            <SrBox marginLeft='20px'>
              <SrText
                font='greycliff'
                color='fontBlueDark'
                size='24'
                lineHeight='32px'
                weight='700'
                display='block'
              >
                Reduce days on market
              </SrText>
              <SrBox marginTop='8px'>
                <SrText
                  font='greycliff'
                  color='grey500'
                  size='16'
                  lineHeight='24px'
                  weight='600'
                  display='block'
                >
                  Get a lease signed 26% faster than the market average
                </SrText>
              </SrBox>
            </SrBox>
          </SrFlex>
        </SrBox>
      </SrBox>
      <img
        src='/images/property-performance.jpg'
        alt='app preview'
        width={isMediumScreen ? '100%' : '48%'}
        style={{
          margin: isLargeScreen ? '26px auto 0' : '-16px 0 0',
          flexShrink: '0',
          order: isLargeScreen ? -1 : 0,
          display: 'block',
        }}
      />
    </Container>
  );
};

PartnerAgentOwnerMarketingPagePropertyPerformance.displayName = 'PartnerAgentOwnerMarketingPagePropertyPerformance'; // eslint-disable-line max-len

export default PartnerAgentOwnerMarketingPagePropertyPerformance;
